import styled from "@emotion/styled";

export const StaticBackground = styled.div({
  position: "fixed",
});

export const Title = styled.div({
  fontSize: "15vw",
  fontWeight: 600,
  paddingBottom: 0,
  marginBottom: 0,
  marginTop: "30vh",
});
